<div *ngIf="products.length === 0" class="px-28">
  <p class="font-medium text-lg pb-3 subpixel-antialiased">
    You do not have any EAC enabled funds, please contact us on
    <strong>{{constants.callCenterNumber}}</strong> should you require assistance
  </p>
</div>
<div *ngIf="products.length > 0" class="px-28">
  <p class="font-medium text-lg pb-3 subpixel-antialiased">
    List of your EAC enabled funds
  </p>
  <p class="font-medium text-md mt-3 subpixel-antialiased">
    {{
      collapsed == true
        ? "Please choose your products:"
        : "Please
    choose the Investments you would like to make changes to:"
    }}
  </p>
  <div class="w-3/5">
    <div class="mt-3 relative">
      <button
        (click)="toggleCollapse()"
        type="button"
        aria-haspopup="listbox"
        aria-expanded="true"
        aria-labelledby="listbox-label"
        class="
          relative
          w-full
          h-16
          border-1p
          font-extralight
          text-sm text-gray-400
          border-black
          rounded-md
          pl-3
          pr-10
          py-2
          text-left
          cursor-default
          focus:outline-none
          sm:text-sm
        "
        [ngClass]="{ 'rounded-b-none border-no-bottom': !collapsed }"
      >
        <span class="block truncate">
          {{ selectedProduct.Participant }}
        </span>
        <span
          class="
            absolute
            inset-y-0
            right-0
            flex
            items-center
            pr-4
            pointer-events-none
          "
        >
          <svg
            class="w-7 h-7 text-orange-forbes"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="1.5"
              d="M19 9l-7 7-7-7"
            />
          </svg>
        </span>
      </button>
      <div
        class="
          absolute
          w-full
          bg-gray-100
          rounded-md
          border-no-top
          rounded-t-none
          border-black
        "
        [ngClass]="{ 'border-1p': !collapsed }"
      >
        <ul
          [hidden]="collapsed"
          tabindex="-1"
          role="listbox"
          aria-labelledby="listbox-label"
          aria-activedescendant="listbox-item-3"
          class="
            rounded-md
            py-1
            space-y-4
            font-extralight
            max-h-28
            text-sm text-gray-400
            overflow-y-auto
            focus:outline-none
            sm:text-sm
          "
        >
          <li
            *ngFor="let product of products"
            id="{{ product.FundId }}"
            (click)="updateProductSelection(product); collapsed = !collapsed"
            role="option"
            class="
              cursor-pointer
              hover:text-orange-forbes
              select-none
              relative
              py-2
              pl-3
              pr-9
            "
          >
            <span class="block truncate">
              {{ product.Participant }}
            </span>
            <span
              class="
                text-orange-forbes
                absolute
                inset-y-0
                right-0
                flex
                items-center
                pr-4
              "
              *ngIf="product.FundId == selectedProduct.FundId"
            >
              <svg
                class="h-5 w-5"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 20 20"
                fill="currentColor"
                aria-hidden="true"
              >
                <path
                  fill-rule="evenodd"
                  d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                  clip-rule="evenodd"
                />
              </svg>
            </span>
          </li>
        </ul>
      </div>
    </div>
    <div class="flex items-center my-8">
      <div>
        <button
          [disabled]="selectedProduct.FundId == null"
          (click)="viewProductInfo()"
          class="
            uppercase
            bg-orange-forbes
            p-2
            disabled:cursor-not-allowed
            font-light
            text-sm
            rounded-md
            text-white
            w-40
            h-14
          "
        >
          View my eac
        </button>
      </div>
    </div>
    <div class="flex items-center my-8">
      <div>
        <p class="text-sm">
          Contact us on <strong>{{constants.callCenterNumber}}</strong> should you require
          assistance.
        </p>
      </div>
    </div>
  </div>
</div>
